import { PubsubTopic } from "@megaron/pubsub-contracts";
import { Serializers } from "@megaron/serializers";

export const blikCheckSyncRequestedTopic: PubsubTopic<Record<string, never>> = {
  name: "loyalty-orders-blik-check-sync-requested",
  serializer: Serializers.object({}),
};
